import { mergeStyles } from "@fluentui/react";
import { Box } from "@mui/material";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { useCallback, useEffect } from "react";
import { logPageView } from "../helper/AppInsightsHelper";
import GlossaryBreadCrumb from "../MuiComponents/GlossaryBreadCrumb";
import { useGetCountryCodeAndKpisQuery } from "../slices/Common.slice";

export default function Glossary() {
  const kpisList = useGetCountryCodeAndKpisQuery(null);
  const columns: GridColDef[] = [
    {
      headerName: "Metric Name",
      field: "name",
      width: 150,
      renderCell: (params) => (
        <span
          style={{
            fontSize: 12,
            whiteSpace: "normal",
            wordWrap: "break-word"
          }}
          title={params.row.name || "N/A"}
        >
          {params.row.name || "N/A"}
        </span>
      ),

      sortable: true
    },
    {
      headerName: "Metric Definition",
      field: "definition",
      width: 1500,
      flex: 0.6,
      renderCell: (params) => (
        <span
          style={{
            fontSize: 12,
            whiteSpace: "nowrap",
            wordWrap: "break-word",
            textOverflow: "ellipsis"
          }}
          title={params.row.definition}
        >
          {params.row.definition}
        </span>
      ),
      sortable: true
    }
  ];
  const getRowId = useCallback(() => crypto.randomUUID(), []);

  useEffect(() => logPageView("Glossary Page", window.location.href), [kpisList.isSuccess]);

  return (
    <div
      className={mergeStyles({
        paddingInline: 10
      })}
    >
      <GlossaryBreadCrumb />

      <Box
        sx={{
          height: "calc(100vh - 112px)",
          marginInline: "8px"
        }}
      >
        <DataGrid
          rows={kpisList?.data?.productKpis}
          columns={columns}
          pageSizeOptions={[25, 50, 75, 100]}
          getRowId={getRowId}
          columnHeaderHeight={40}
          disableColumnMenu
          disableColumnFilter
          disableRowSelectionOnClick
          disableColumnSelector
          hideFooterPagination={false}
          hideFooter={false}
          loading={kpisList.isLoading}
          slotProps={{
            loadingOverlay: {
              variant: "skeleton",
              noRowsVariant: "skeleton"
            }
          }}
          initialState={{
            pagination: {
              paginationModel: { page: 0, pageSize: 25 }
            }
          }}
        />
      </Box>
    </div>
  );
}
